export const mergeArrays = (arrays) => [].concat([], ...arrays)
